export enum FieldType {
  text = 'text',
  numeric = 'numeric'
}



// WEBPACK FOOTER //
// ./client/app/models/fieldType.ts